export const NO_CHANGES_VALUE = 'NO_CHANGES';
export const VALID_ADDRESS_SCORE = '100';
